
import AddStoresToUser from './AddStoresToUser';
import React from 'react';
export default AddStoresToUser;